//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex';
export default {
    name: 'TopicPill',
    props: {
        selectedTopic: {
            type: Object,
            default: () => {}
        },
        topic: {
            type: Object,
            default: () => {}
        }
    }
};
